import { render, staticRenderFns } from "./tabImportManifest.vue?vue&type=template&id=bf32024c&"
import script from "./tabImportManifest.vue?vue&type=script&lang=js&"
export * from "./tabImportManifest.vue?vue&type=script&lang=js&"
import style0 from "./tabImportManifest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf32024c')) {
      api.createRecord('bf32024c', component.options)
    } else {
      api.reload('bf32024c', component.options)
    }
    module.hot.accept("./tabImportManifest.vue?vue&type=template&id=bf32024c&", function () {
      api.rerender('bf32024c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabImportManifest.vue"
export default component.exports